import React from 'react';
import type { EvaluationItem, ShortAnswerConfig } from '../../../../../types/course';
import FloatingLabelPill from '../shared/FloatingLabelPill';
import AnswerPill from '../shared/AnswerPill';
import SectionHeader from '../shared/SectionHeader';
import TrashButton from '../shared/TrashButton';

interface ItemEditorProps {
  item: Extract<EvaluationItem, { type: 'short_answer_text' }>;
  onChange: (patch: Partial<Extract<EvaluationItem, { type: 'short_answer_text' }>>) => void;
  onDelete: () => void;
  readOnly?: boolean;
}

export default function ShortAnswerTextItem({ item, onChange, onDelete, readOnly }: ItemEditorProps) {
  const { question, expected_answer, case_sensitive } = item.config;

  const updateConfig = (patch: Partial<ShortAnswerConfig>) => {
    onChange({ config: { ...item.config, ...patch } });
  };

  return (
    <div className="flex flex-col gap-[31px] w-full">
      <SectionHeader title="Short Answer" />
      <FloatingLabelPill
        label="Question"
        value={question}
        onChange={(v) => updateConfig({ question: v })}
        placeholder="Ask a question with a short exact answer"
        size="xl"
        readOnly={readOnly}
        trailingIcon={!readOnly && <TrashButton onClick={onDelete} ariaLabel="Delete question" />}
      />
      <AnswerPill
        value={expected_answer}
        onChange={(v) => updateConfig({ expected_answer: v })}
        placeholder="Expected answer"
        state="selected"
        readOnly={readOnly}
      />
      <label
        className={`flex items-center gap-2 self-start font-sans text-[13px] text-text-secondary ${
          readOnly ? 'cursor-default' : 'cursor-pointer'
        }`}
      >
        <input
          type="checkbox"
          checked={!!case_sensitive}
          onChange={(e) => updateConfig({ case_sensitive: e.target.checked })}
          disabled={readOnly}
          className="accent-primary-500"
        />
        Case sensitive
      </label>
    </div>
  );
}
